import { render, staticRenderFns } from "./matrixlike.vue?vue&type=template&id=3a4021ee"
import script from "./matrixlike.vue?vue&type=script&lang=js"
export * from "./matrixlike.vue?vue&type=script&lang=js"
import style0 from "./matrixlike.vue?vue&type=style&index=0&id=3a4021ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports